import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Angle from '../../Angle';
import Button from '../../Button';
import { getAsset } from '../../../../util/assets';
import useOpenModal from '../../../../hooks/useOpenModal';
import { PURCHASED_EVENT_ADDON_FEATURES } from '../../../../apps/pro/services/featurePermissions/helpers';
import { FREEMIUM_EVENTS_META } from '../../../../apps/pro/components/FreemiumEventPurchase/helpers';
import { EVENT_ADDON_ITEM_UPSELL_MODAL } from '../../EventAddonItemUpsell';
import EventAddonItemUpsellModal from '../../EventAddonItemUpsell/modal';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../constants/event-items';
import useIsNativeWebView from '../../../../services/native-bridge/hooks/useIsWebView';

const propTypes = {
  featureId: PropTypes.string,
  albumId: PropTypes.string,
  albumFolderId: PropTypes.string.isRequired,
  albumSubType: PropTypes.oneOf(Object.keys(FREEMIUM_EVENTS_META)),
  className: PropTypes.string,
  withModal: PropTypes.bool,
};

const FEATURE_TITLES = {
  [PURCHASED_EVENT_ADDON_FEATURES.white_label_marketing_prints_enabled]:
    'Remove watermark and unlock more features',
  [PURCHASED_EVENT_ADDON_FEATURES.free_joins_enabled]:
    'Upgrade your event to activate auto-tagging for EVERY guest!',
  [PURCHASED_EVENT_ADDON_FEATURES.custom_hashtag_enabled]:
    'Edit your hashtag, add a custom photo overlay, and unlock more features',
  [PURCHASED_EVENT_ADDON_FEATURES.join_code_enabled]:
    'Create a unique join code for your guests and unlock more features',
  [PURCHASED_EVENT_ADDON_FEATURES.qr_code_enabled]:
    'Unlock more design options & remove Waldo branding',
  [PURCHASED_EVENT_ADDON_FEATURES.require_review]:
    'Review uploaded photos before publishing and unlock more features',
};

const WaldoficationFeatureUpsellBanner = ({
  featureId,
  albumFolderId,
  albumId,
  albumSubType,
  className,
  withModal = true,
}) => {
  const isNativeView = useIsNativeWebView();
  const openModal = useOpenModal();
  const classes = classNames({
    'waldofication-feature-upsell-banner': true,
    [className]: !!className,
  });

  if (isNativeView) {
    return null;
  }

  return (
    <Fragment>
      <Button
        btnStyle="reset"
        className={classes}
        onClick={() =>
          openModal(EVENT_ADDON_ITEM_UPSELL_MODAL, {
            albumId,
            albumFolderId,
            albumSubtype: albumSubType,
            eventAddonItemType: EVENT_ADDON_ITEM_TYPE.WALDOFIED,
          })
        }
      >
        <div className="d-flex align-items-center">
          <img
            src={getAsset('/diamond-orange.svg')}
            alt="Unlock your potential"
            className="mr-2"
            width="27"
          />
          <span>{FEATURE_TITLES[featureId] ?? ''}</span>
        </div>
        <Angle
          direction="right"
          className="waldofication-feature-upsell-angle"
        />
      </Button>
      {withModal && <EventAddonItemUpsellModal albumSubtype={albumSubType} />}
    </Fragment>
  );
};

WaldoficationFeatureUpsellBanner.propTypes = propTypes;

export default WaldoficationFeatureUpsellBanner;
